function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.29251 17.6857C4.08251 17.4757 3.97751 17.1837 4.00351 16.8877L4.38251 12.7177C4.42451 12.2607 4.62651 11.8297 4.95251 11.5037L13.9485 2.5077C14.6505 1.8027 15.9235 1.8377 16.6645 2.5767L19.4025 5.3147L19.4035 5.3157C20.1685 6.0817 20.1995 7.2997 19.4715 8.0297L10.4745 17.0267C10.1495 17.3517 9.71851 17.5537 9.26051 17.5957L5.09051 17.9747C5.06051 17.9767 5.03051 17.9777 4.99951 17.9777C4.73651 17.9777 4.48151 17.8737 4.29251 17.6857ZM16.0185 8.6567L13.3235 5.9617L15.2715 4.0127L17.9655 6.7067L16.0185 8.6567ZM9.07951 15.6027L6.10251 15.8737L6.36651 12.9177L11.9835 7.3007L14.6795 9.9977L9.07951 15.6027ZM18.9995 21.9777C19.5495 21.9777 19.9995 21.5277 19.9995 20.9777C19.9995 20.4287 19.5495 19.9777 18.9995 19.9777H4.99951C4.45051 19.9777 3.99951 20.4287 3.99951 20.9777C3.99951 21.5277 4.45051 21.9777 4.99951 21.9777H18.9995Z",
  fill: "#24252B"
});

function SvgEdit2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit-2.2d438da1.svg";
export { ForwardRef as ReactComponent };